import shop from "@/api/stockGroups";

// initial state
const state = {
  all: [],
  stockGroup: {}
};

// getters
const getters = {
  stockGroup: state => {
    return state.stockGroup;
  },
  stockGroupCategories: state => {
    return state.all.map(m => {
      return {
        name: m.stockGroupCategory
          ? m.stockGroupCategory.name + " - " + m.name
          : m.name,
        id: m.id
      };
    });
  }
};

// actions
const actions = {
  getAllStockGroups: async context => {
    let d = (await shop.getStockGroups()).data;
    context.commit("getStockGroups", d);
  },
  searchStockGroup: async (context, stockGroup) => {
    let d = (await shop.searchStockGroup(stockGroup)).data;
    context.commit("getStockGroups", d);
    return d;
  },
  getStockGroup: async (context, id) => {
    let d = (await shop.getStockGroup(id)).data;
    context.commit("getStockGroup", d);
    return d;
  },
  postStockGroup: async (context, stockGroup) => {
    const result = (await shop.postStockGroup(stockGroup)).data;
    context.commit("postStockGroup", result);
  },
  putStockGroup: async (context, stockGroup) => {
    const result = (await shop.putStockGroup(stockGroup)).data;
    context.commit("putStockGroup", result);
  },
  deleteStockGroup: async (context, stockGroup) => {
    (await shop.deleteStockGroup(stockGroup)).data;
    context.commit("deleteStockGroup", stockGroup);
  }
};

// mutations
const mutations = {
  getStockGroups(state, stockGroups) {
    state.all = stockGroups;
  },
  getStockGroup(state, stockGroup) {
    //state.stockGroup = stockGroup
    state.stockGroup = null;
    state.stockGroup = Object.assign({}, state.stockGroup, stockGroup);
  },
  postStockGroup(state, stockGroup) {
    //state.stockGroup = stockGroup
    state.stockGroup = null;
    state.stockGroup = Object.assign({}, state.stockGroup, stockGroup);
  },
  putStockGroup(state, stockGroup) {
    //state.stockGroup = stockGroup
    state.stockGroup = null;
    state.stockGroup = Object.assign({}, state.stockGroup, stockGroup);
  },
  deleteStockGroup(state, stockGroup) {
    state.all.splice(state.all.indexOf(stockGroup), 1);
  },
  decrementStockGroupInventory(state, { id }) {
    const stockGroup = state.all.find(stockGroup => stockGroup.id === id);
    stockGroup.inventory--;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
